import { gql, TypedDocumentNode } from "@apollo/client";

import { SearchSuggestionsInput, SearchSuggestionsPossibleValuesString } from "types/generated";

type NewModuleSearchModuleSuggestionsData = {
  searchModulesSuggestions: {
    fields: {
      possibleValuesString: Pick<
        SearchSuggestionsPossibleValuesString,
        "values" | "counts"
      > | null;
    }[];
  };
};

type NewModuleSearchModuleSuggestionsVariables = {
  input: SearchSuggestionsInput;
};

export const SEARCH_MODULE_NAME_SUGGESTIONS: TypedDocumentNode<
  NewModuleSearchModuleSuggestionsData,
  NewModuleSearchModuleSuggestionsVariables
> = gql`
  query NewModuleSearchModuleSuggestions($input: SearchSuggestionsInput!) {
    searchModulesSuggestions(input: $input) {
      fields {
        possibleValuesString {
          values
          counts
        }
      }
    }
  }
`;
